export default "__VITE_ASSET__PZdsCUOj__"